export default {
  registration: {
    name: "Nom",
    institution: "Établissement",
    component: "Composante",
    trainingCourse: "Promotion",
    group: "Groupe",
    Contact: "Contact",
    registration_settings: "Paramétrage inscription",
    pedagogicInformations: "Informations pédagogiques",
    fundingInformations: "Informations financières",
    dates: "Dates",
    from_to: "du {from} au {to}",
    hourlyVolume: "Volume horaire",
    hourlyRemoteVolume: ({ named }) => `Dont ${named("volume")} h à distance`,
    modality: ({ plural }) => plural(["Modalité", "Modalités"]),
    in_person: "Présentiel",
    distanciel: "Distanciel",
    remoteVolume: "Dont enseignement à distance",
    degreePrepared: "Diplôme préparé",
    level: "Niveau",
    titleRncp: "Titre RNCP",
    degreeCode: "Code diplôme",
    calendar: "Calendrier",
    program: "Programme",
    apprenticeShipContract: "Contrat d'apprentissage",
    proContract: "Contrat de professionnalisation",
    rate: "Tarif",
    publicAnnualRate: "Coût annuel employeurs publics",
    annualRate: "Coût annuel",
    totalRate: "Coût total",
    hourlyRate: "Tarif horaire",
    followUp: "Suivi du dossier",
    devices: "Dispositifs",
    createdAt: "crée le {date}",
    help: "Aide",
    follow: "Suivi",
    inProgress: "En cours",
    validatedAt: "Validé le {date} par {validator}",
    steps: "Les étapes",
    statistics: "Statistiques",
    generalInformations: "Informations générales",
    civility: "Civilité",
    firstName: "Prénom",
    birthDate: "Date de naissance",
    age: "Âge",
    email: "Email",
    phone: "Téléphone",
    address: "Adresse",
    nationality: "Nationalité",
    male: "M.",
    female: "Mme.",
    years: "ans",
    apprentice: "Apprenti",
    tutor: "Tuteur",
    map: "Maitre d'apprentissage",
    function: "Fonction",
    contacts: "Contacts",
    previousSituation: "Situation antérieur",
    ineCode: "Code INE",
    preContractSituation: "Situation avant contrat",
    lastDegreeObtained: "Dernier diplôme obtenu",
    title: "Intitulé",
    lastDegreePrepared: "Dernier diplôme préparé",
    lastInstitution: "Dernier établissement",
    uaiCode: "Code UAI",
    department: "Département",
    socialReason: "Raison sociale",
    company: "Entreprise",
    head_office: "Siège social",
    activityCode: "Code d'activité (NAF)",
    totalWorkForce: "Effectif total",
    siret: "SIRET",
    employerType: "Type d'employeur",
    employerSubType: "Sous-type d'employeur",
    idcc: "IDCC",
    opco: "OPCO",
    hostCompany: "Entreprise d'accueil",
    administratorCompany: "Siège de l'entreprise",
    training: "Formation",
    startDate: "Date de début",
    endDate: "Date de fin",
    hourlyTrainingVolume: "Nombre d'heures",
    apprenticeMaster: "Maitre d'apprentissage",
    apprenticeMaster2: "Maitre d'apprentissage 2",
    degree: "Diplôme",
    hostCompanyContact: "Contact entreprise d'accueil",
    administratorCompanyContact: "Contact siège entreprise",
    pricePolicyInfo1:
      "Reste à charge uniquement si la prise en charge est inférieure ; la prise en charge plafonnée au tarif, même si elle est supérieure.",
    pricePolicyInfo2:
      "Reste à charge uniquement si la prise en charge est inférieure au tarif ; si supérieure, on applique le tarif en fonction de la prise en charge.",
    pricePolicyInfo3: "Le tarif est aligné sur la prise en charge.",
    signIn: "Créer un compte",
    login: "Se connecter",
    loginInfo: "Authentifiez-vous ou créez un compte pour accéder à la fiche d’inscription",
    loginInfo2: "Authentifiez-vous pour accéder à la fiche d’inscription",
    needAccount: "Je n'ai pas de compte",
    noNeedAccount: "J'ai déjà un compte",
    anApprentice: "Un.e alternant.e",
    aCompany: "Une entreprise",
    iAm: "Je suis",
    createApprenticeAccount: "Créer un compte alternant.e",
    createCompanyAccount: "Créer un compte entreprise",
    accountExist: "Votre e-mail a été reconnu !",
    accountExistSubTitle: "Vous pouvez vous connecter directement à votre compte avec vos identifiants !",
    next: "Suivant",
    prev: "Précédent",
    workInProgress: "À valider",
    valid: "Validé",
    pending: "En cours",
    publicSector: "Secteur public",
    privateSector: "Secteur privé",
    link_copied_success: "Lien copié dans le presse-papier avec succès !",
    status: {
      upcoming: "À venir",
      in_progress: "En cours",
      finalised: "Finalisé",
      break_up: "Rupture",
      cancelled: "Annulé",
    },
    insee_company: {
      title: ({ plural }) => plural(["Entreprise INSEE ", "Entreprises INSEE"]),
      siret: "SIRET",
      activity: "Activité (NAF/APE)",
      details: "Détails (nom, enseigne, adresse)",
      creation: "Création",
      state: "État",
      social_reason: "Raison sociale",
      current: "Établissement courant",
      head_office: "Siège de la société",
      creation_date: "Date de création",
      work_force: "Effectif",
      status: "Statut",
      principal_address: "Adresse principale",
      secondary_address: "Adresse secondaire",
      empty_contact: "Aucun contact n'est renseigné pour cette entreprise",
    },
    training_info: {
      search_by_branch: "Recherche par convention collective",
      funding_coverage: "Prise en charge :",
      decree_cost: "Coût décret : ",
      only_different_cost_displayed: "Par défaut, seuls les coûts différents du coût décret sont affichés",
      info_tab: {
        general_info: "Informations générales",
        rncp_sheet: "Fiche RNCP",
        program: "Programme",
        setttings: "Paramétrage inscription",
        settings: "Paramétrage inscription",
        npec: "NPEC",
        contact: "Contact pour les entreprises",
      },
      general_info: {
        institution_name: "Nom de l'établissement",
        reference: "Référence",
        rncp_number: "Numéro RNCP",
        offical_name: "Nom officiel",
        diplome_type: "Type de diplôme",
        mention: "Nom / mention",
        route: "Parcours",
        diplome_code: "Code diplôme",
        status: "Statut",
        logo: "Logo",
        partner_website_url: "URL du site partenaire",
        link: "Lien",
        work_study_duration: "Durée de l'alternance",
        total_cycle_time: "Durée total du cycle",
        active: "Active",
        archived: "Archivée",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Alerte ", "Alertes"]),
      level: {
        info: "Information",
        warning: "Alerte",
        error: "Erreur",
      },
      active_unactive: "Activer/Désactiver",
      see_more: "Voir plus",
      empty: "Aucune alerte de niveau {level}",
    },
    group_action: {
      see_sheet: "Voir la fiche de pré-inscription",
      copy_sheet: "Copier le lien de la fiche de pré-inscription",
      create: "Créer une fiche de pré-inscription",
      see_group_detail: "Voir les détails du groupe",
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer ce groupe ?",
        success: "Groupe supprimé avec succès !",
      },
    },
    dashboard: {
      go_to: "Accéder au tableau de bord de cette formation",
    },
    creation: {
      info: "Pour créer une nouvelle fiche d'inscription, veuillez d'abord saisir les informations du candidat",
      success: ({ named }) =>
        `Fiche de pré-inscription de ${named("firstName")} ${named("lastName")} créée avec succès !`,
    },
    user_not_connected: "Vous devez vous connecter pour accéder à cet espace",
    quote: {
      contract: "Contrat",
      financial: "Financement",
      amount: "Grille des montants",
      edit_cost: "Modifier les coûts",
      subtitle: "Récapitulatif financier du contrat d'apprentissage",
      initial_cost: "Coût initial",
      final_cost: "Coût final",
      modal_alert:
        "Ces modifications affecteront le montant facturé à l'entreprise. Assurez-vous que les montants sont conformes à votre convention.",
      discount: ({ named }) => `Remise commerciale : ${named("economy")} (${named("discount")})`,
      edit: {
        date: {
          title: "Modifier les dates du contrat",
          success: "Modification des dates du contrat effectuée avec succès !",
        },
        cost: {
          title: "Modifier les montants",
          success: "Montants modifiés avec succès !",
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Coût de la formation",
          opcoo: "Prise en charge",
          mandatory_participation: "Participation obligatoire",
          remaining_cost: "Reste à charge",
        },
      },
      duration: {
        title: "Durée",
      },
      billingStartDate: {
        title: "Date de début",
      },
      billingEndDate: {
        title: "Date de fin",
      },
    },
    contact: {
      title: "Un contact",
      success: "Contact ajouté avec succès !",
      delete: {
        confirmation: "Êtes-vous sûr de vouloir supprimer ce contact ?",
        success: "Contact supprimé avec succès !",
      },
    },
    contractType: {
      apprentice: "Apprenti.e.s",
      pro: "Contrat pro",
    },
    document: {
      baseline: "Document à imprimer, signer et à importer ci-dessous",
      cerfa: {
        title: "CERFA",
      },
      convention: {
        title: "Convention",
      },
      update: {
        success: ({ named }) => `Votre ${named("document")} à été enregistré avec succès !`,
      },
    },
    step: {
      validation: {
        success: "Étape validée avec succès !",
      },
    },
    save: {
      success: "Votre fiche d'inscription a été enregistrée avec succès !",
    },
    contract_status: {
      init: "Initialisée",
      to_send_to_training_center: "À envoyer",
      sent_to_training_center: "Envoyée",
      validated_training_center: "Validée",
      signed: "Signée",
      error: "Erreur",
      archived: "Archivée",
    },
    download_training_sheet: "Télécharger la fiche information de la formation",
    create: {
      confirmation: "Êtes-vous sûr de vouloir vous créer une nouvelle fiche de pré-inscription ?",
    },
    contract: {
      empty: "Aucun contrat disponible",
      see: "Accéder au contrat",
    },
    empty_registation_list: "Aucune fiche de préinscription disponible",
    empty_document: "Aucun document",
    company_dashboard: {
      following_contract: {
        title: "Liste des contrats",
      },
    },
  },
};
